import * as React from 'react'

import { cn } from '../lib/utils'

export interface AttentionDotProps {
  /** What the dot means, read to screen readers. The mark itself is aria-hidden. */
  label?: string
  className?: string
}

/**
 * The 7px "there's something new here" dot — a slow expanding ring around a filled dot.
 * Sits beside a label; the label text is what reaches assistive tech.
 *
 * Amber, not brand green: it clears 3:1 on both the card and the dark green footer bar, in
 * both themes, so one colour covers every surface. `--dot-pulse` drives the ring so it can
 * never drift from the dot.
 */
export function AttentionDot({ label, className }: AttentionDotProps) {
  return (
    <>
      <span
        aria-hidden
        className={cn(
          'inline-block size-[7px] flex-shrink-0 rounded-full bg-amber [--dot-pulse:oklch(var(--amber))] motion-safe:animate-dot-pulse',
          className
        )}
      />
      {label && <span className="sr-only">{label}</span>}
    </>
  )
}
